import React from 'react';
import '../gral-stylesheets/subtitles.scss';



class Subtitles extends React.Component {
  render() {
    let darkText = this.props.darkText;
    return (
      <div className='subtitles'>
        <h5>{this.props.titleSmall}</h5>
        <div className='header-big-text'>
          <h2 className={ darkText ? 'text-dark' : 'text-clear'}>{this.props.titleBig}</h2>
        </div>
      </div>
    );
  }
}

export default Subtitles;


